import React, { useState, useEffect, useRef } from 'react';

//import para inicio de sesion y consultas
import { onAuthStateChanged } from 'firebase/auth';
import { auth, getUserInfo } from '../../firebase/firebase';

//import para ver permisos
import { hasPermission } from '../../firebase/permisos';

//import para navigate
import { useNavigate } from 'react-router-dom';

//importacion del MENU
import Menu from '../menu';
import HeaderHome from '../header';

//import para funciones especificas de esta pantalla
import { getAllProviders, deleteProviderById, deleteProvidersByIds } from '../../firebase/proveedores.js'
import { getAllCompanies } from '../../firebase/empresas.js'

import { Link } from 'react-router-dom';

//modal de carga
import LoadingModal from '../Loading-Modal/loading.jsx'
import '../Usuarios/usuarios.css';
import '../Requisiciones/requisicion_solicitadas.css'
import '../Requisiciones/historial_requisiciones.css'

//import de iconos
import { AiFillCloseCircle } from 'react-icons/ai';
import { CiMenuKebab } from 'react-icons/ci';
import { GrFormEdit } from 'react-icons/gr';
import { FiTrash2 } from 'react-icons/fi';
import { MdArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';


import Modal from '../Modal/Modal.jsx'


function ListadoProveedores(props) {

    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false); // Estado para controlar el modal de carga


    const [useUser, setUseUser] = useState({
        nombre: '',
        rol: '',
        email: '',
        genero: '',
        fechaIni: '',
        cumple: '',
        tel: '',
        foto: ''
    });

    const [loading, setLoading] = useState(true);
    const hasCheckedPermission = useState(false);
    const [Providers, setProviders] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState({});


    //Estado para manejar el listado de compañias o empresas a mostrar en el Dropdown
    const [companies, setCompanies] = useState([]);

    // Estado para rastrear qué proyecto han sido seleccionados
    const [selectedProviders, setselectedProviders] = useState([]);
    const [selectAll, setSelectAll] = useState(false); // Estado para el checkbox de la cabecera


    const toggleDropdown = (providerID) => {
        setDropdownOpen(prevState => ({
            ...prevState,
            [providerID]: !prevState[providerID]
        }));
    };

    const dropdownRef = useRef(null);

    //AQUI ESTA EL MODAL
    const [showModal, setShowModal] = useState(false);
    const [showModalForprojectID, setShowModalForProjectId] = useState(null);

    const [showMultiDeleteModal, setShowMultiDeleteModal] = useState(false);

    const handleTrashClick = (projectID) => {
        setShowModalForProjectId(projectID);
    };
    //AQUI TERMINA EL MODAL

    useEffect(() => {
        if (!hasCheckedPermission.current) {
            onAuthStateChanged(auth, handleProviderstateChanged);
            hasCheckedPermission.current = true;
        }

        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                if (event.target.className !== 'dontCloseDropdown' && !showModal) {
                    setDropdownOpen({});
                }
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);


    async function handleProviderstateChanged(user) {
        if (user) {
            setIsLoading(true);
            try {
                const res = await getUserInfo(user.uid);
                if (res != null) {
                    setUseUser(prevState => ({
                        ...prevState,
                        nombre: res.nombre,
                        rol: res.rol,
                        email: res.email,
                        genero: res.genero,
                        fechaIni: res.fechaIni.toDate().toLocaleDateString(),
                        cumple: res.cumple.toDate().toLocaleDateString(),
                        tel: res.tel,
                        foto: res.foto
                    }));

                    //cargar las empresas
                    const companyList = await getAllCompanies();
                    setCompanies(companyList);

                    setLoading(false); // para saber si termino de cargar los datos de las empresas

                    const canAccess = await hasPermission(res.rol, "proveedores/listado");
                    if (!canAccess) {
                        props.showErr('Usted no tiene permisos para acceder a esta función.')
                        navigate('/home');
                        return;
                    }

                    setProviders(await getAllProviders());

                } else {
                    setUseUser(prevState => ({
                        ...prevState,
                        nombre: 'N/A',
                        rol: 'N/A',
                        email: 'N/A',
                        genero: 'N/A',
                        fechaIni: 'N/A',
                        cumple: 'N/A',
                        tel: 'N/A',
                        foto: 'N/A'
                    }));
                }
                setIsLoading(false);
            } catch {
                console.log('NO HAY USUARIO :(');
                navigate('/login');
            }
        } else {
            navigate('/login');
        }
    }


    //AQUI ESTA EL PAGINADOR
    const [currentPage, setCurrentPage] = useState(() => {
        const savedPage = localStorage.getItem('currentPageProveedores');
        return savedPage ? Number(savedPage) : 1;
    });
    const [itemsPerPage] = useState(4);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    const totalItems = Providers.length;
    const [totalPages, setTotalPages] = useState(0);

    const paginate = (pageNumber) => {
        setCurrentPage(pageNumber);
        localStorage.setItem('currentPageProveedores', pageNumber);
    };


    const [searchName, setSearchName] = useState('');
    const [SearchContacto, setSearchContacto] = useState('');
    const [SearchGiro, setSearchGiro] = useState('');

    const InputChangeUsr = (event) => {
        const { name, value } = event.target;
        if (name === 'nombre') {
            setSearchName(value);
            //local storage
            saveFiltersToLocalStorage({
                searchName: value,
                SearchContacto,
                SearchGiro
            });

        } else if (name === 'searchContacto') {
            setSearchContacto(value);

            //local storage
            saveFiltersToLocalStorage({
                searchName,
                SearchContacto: value,
                SearchGiro
            });

        } else if (name === 'searchGiro') {
            setSearchGiro(value);

            //local storage
            saveFiltersToLocalStorage({
                searchName,
                SearchContacto,
                SearchGiro: value
            });

        }
        if (value) {
            document.getElementById(name).classList.add('input-active');
        } else {
            document.getElementById(name).classList.remove('input-active');
        }
        setExecutionCount(prevCount => prevCount + 1); // Incrementa el contador
    };

    const filteredProviders = Providers.filter(provider => {
        const nameMatches = provider.name.toLowerCase().includes(searchName.toLowerCase());

        // Solo incluirá proveedores cuyo contacto coincida o, si SearchContacto está vacío, aquellos que tengan el campo vacío.
        const contactMatches = SearchContacto.trim() === '' ?
            (!provider.contact || provider.contact.toLowerCase().includes(SearchContacto.toLowerCase())) :
            (provider.contact && provider.contact.toLowerCase().includes(SearchContacto.toLowerCase()));

        // Solo incluirá proveedores cuyo giro coincida o, si SearchGiro está vacío, aquellos que tengan el campo vacío.
        const giroMatches = SearchGiro.trim() === '' ?
            (!provider.business_turnover || provider.business_turnover.toLowerCase().includes(SearchGiro.toLowerCase())) :
            (provider.business_turnover && provider.business_turnover.toLowerCase().includes(SearchGiro.toLowerCase()));

        return nameMatches && contactMatches && giroMatches;
    });

    useEffect(() => {
        setTotalPages(Math.ceil(filteredProviders.length / itemsPerPage));
    }, [filteredProviders, itemsPerPage]);

    const [executionCount, setExecutionCount] = useState(0);

    //Restaurar los Filtros desde localStorage al Cargar la Página
    useEffect(() => {
        const savedFilters = JSON.parse(localStorage.getItem('filtersProviders'));
        if (savedFilters) {
            setSearchName(savedFilters.searchName || '');
            setSearchContacto(savedFilters.SearchContacto || '');
            setSearchGiro(savedFilters.SearchGiro || '');
        }

        const savedPage = localStorage.getItem('currentPageProveedores');

        if (savedPage) {
            setCurrentPage(Number(savedPage));
        }

    }, []);

    useEffect(() => {
        setExecutionCount(prevCount => prevCount + 1); // Incrementa el contador

        const lastURL = localStorage.getItem('lastURL');
        if ((executionCount >= 3) || (lastURL != 'proveedores/listado')) {
            setCurrentPage(1);
            localStorage.setItem('currentPageProveedores', 1);
            localStorage.setItem('lastURL', 'proveedores/listado');
        }
    }, [searchName, SearchContacto, SearchGiro]);

    //SECCION PARA MANEJAR HISTORIAL EN FILTROS POR LOCALSTORAGE

    //Guardar los Filtros en localStorage
    const saveFiltersToLocalStorage = (filters) => {
        localStorage.setItem('filtersProviders', JSON.stringify(filters));
    };

    const currentItems = filteredProviders.slice(indexOfFirstItem, indexOfLastItem);


    const [isRoleOpen, setRoleOpen] = useState(false);

    // Efecto para manejar el clic fuera del menú
    useEffect(() => {
        function handleDocumentClick(event) {

            // Verificar si el clic es fuera del menú de roles
            if (isRoleOpen && !event.target.closest('.field-container-usuarios')) {
                setRoleOpen(false);
            }

        }

        document.addEventListener('mousedown', handleDocumentClick);

        return () => {
            document.removeEventListener('mousedown', handleDocumentClick);
        };
    }, [isRoleOpen]); // Dependencias del efecto



    const goToEditProvider = (ProvidersSel) => {
        navigate('./editar', { state: { ProvidersSel } });
    };

    const deleteProviders = async (providerU) => {

        setIsLoading(true);
        try {
            const result = await deleteProviderById(providerU.id);
            if (result.success) {
                // Actualizar el estado para excluir el proyecto eliminado
                setProviders(prevProviders => prevProviders.filter(pr => pr.id !== providerU.id));
                props.ShowDone(`Se elimino el proveedor: ${providerU.name}`);
            } else {
                // Manejar el caso en que la eliminación falla
                props.showErr(`El proveedor ${providerU.name} no se pudo eliminar.`);
                props.ShowWar(result.message);
            }
            setIsLoading(false);

        } catch (error) {
            console.log(error);
            props.showErr(`El proyecto ${providerU.project_name} no se pudo eliminar.`);
            setIsLoading(false);
        }


    };

    // Función para manejar la selección de un proveedor
    const handleProvidersSelect = (prov, isSelected) => {
        if (isSelected) {
            setselectedProviders([...selectedProviders, prov]);
        } else {
            setselectedProviders(selectedProviders.filter(u => u.id !== prov.id));
            setSelectAll(false); // Desactivar el checkbox de la cabecera si un proyecto se deselecciona
        }
    };

    // Función para manejar el cambio en el checkbox de la cabecera
    const handleSelectAllChange = () => {
        setSelectAll(!selectAll);

        if (!selectAll) {
            setselectedProviders(currentItems);
        } else {
            setselectedProviders([]);
        }
    };

    const handleShowModalMulti = () => {
        setShowMultiDeleteModal(true);
        setDropdownOpen({});
    };

    // Función para manejar la eliminación de proveedores seleccionados
    const handleDeleteselectedProviders = async () => {

        setIsLoading(true);
        try {

            // Extrae solo los IDs de cada proveedor
            const providersIds = selectedProviders.map(provider => provider.id);

            const results = await deleteProvidersByIds(providersIds);
            const successfulDeletes = results.filter(result => result.success).map(result => result.id);
            const failedDeletes = results.filter(result => !result.success);

            // Actualizar el estado para excluir los proveedores eliminados exitosamente
            setProviders(prevProviders => prevProviders.filter(pr => !successfulDeletes.includes(pr.id)));

            // Desactivar el checkbox de la cabecera
            setSelectAll(false);

            // Limpiar la lista de proveedores seleccionados
            setselectedProviders([]);

            // Cerrar el modal una vez que se haya completado la eliminación
            setShowMultiDeleteModal(false);

            if ((successfulDeletes.length === selectedProviders.length) && (successfulDeletes.length > 0)) {
                props.ShowDone(`Se eliminaron ${successfulDeletes.length} proveedores`);
            } else {

                if (successfulDeletes.length === 1) {
                    props.ShowDone(`Se elimino el proveedor: ${successfulDeletes[0].name} `);
                } else if (successfulDeletes.length > 0) {
                    props.ShowDone(`Se eliminaron ${successfulDeletes.length} proveedores`);
                }

                failedDeletes.forEach(failed => {
                    props.showErr(`El proveedor no se pudo eliminar.`);
                    props.ShowWar(failed.message);
                });
            }

            setIsLoading(false);

        } catch (error) {
            props.showErr('Ocurrio un error inesperado.');
            console.log(error);
            setIsLoading(false);
        }

    };

    const handleModalDelete = (provID) => {
        const provToDelete = Providers.find(u => u.id === provID);
        if (provToDelete) {
            deleteProviders(provToDelete);
        }
        setShowModalForProjectId(null);  // Cerrar el modal
    };


    return (
        <>
            {!loading && (
                <div>
                    < HeaderHome
                        userLoged={useUser}
                    />

                    <div className='bodyHome-user' style={{ height: "210vh" }}>
                        < Menu
                            userLoged={useUser}
                        />
                        <div style={{ width: "100%" }}>
                            <p>Proveedores</p>
                            <div className='filter-use-p'>
                                <div className='filter-use'>
                                    <form style={{ width: "80%" }}>
                                        <div className='filter-userDetails'>
                                            <label>Nombre</label>
                                            <label>Contacto</label>
                                            <label>Giro de Negocio</label>
                                            <div className="input-with-icon">
                                                <input
                                                    id='nombre'
                                                    name='nombre'
                                                    onChange={InputChangeUsr}
                                                    placeholder="Escribe el nombre del proveedor"
                                                    value={searchName}
                                                />
                                                {searchName &&
                                                    <AiFillCloseCircle className="close-icon-name" onClick={() => {
                                                        setSearchName('');
                                                        //limpiar local storage
                                                        saveFiltersToLocalStorage({
                                                            searchName: '',
                                                            SearchContacto,
                                                            SearchGiro
                                                        });
                                                        document.getElementById('nombre').value = '';
                                                        document.getElementById('nombre').classList.remove('input-active');
                                                    }} />}
                                            </div>
                                            <div className="input-with-icon">
                                                <input
                                                    id='searchContacto'
                                                    name='searchContacto'
                                                    onChange={InputChangeUsr}
                                                    placeholder="Escribe el nombre del contacto"
                                                    value={SearchContacto}
                                                />
                                                {SearchContacto &&
                                                    <AiFillCloseCircle className="close-icon-name" onClick={() => {
                                                        setSearchContacto('');
                                                        //limpiar local storage
                                                        saveFiltersToLocalStorage({
                                                            searchName,
                                                            SearchContacto: '',
                                                            SearchGiro
                                                        });
                                                        document.getElementById('searchContacto').value = '';
                                                        document.getElementById('searchContacto').classList.remove('input-active');
                                                    }} />}
                                            </div>
                                            <div className="input-with-icon">
                                                <input
                                                    id='searchGiro'
                                                    name='searchGiro'
                                                    onChange={InputChangeUsr}
                                                    placeholder="Escribe el giro de negocio"
                                                    value={SearchGiro}
                                                />
                                                {SearchGiro &&
                                                    <AiFillCloseCircle className="close-icon-name" onClick={() => {
                                                        setSearchGiro('');
                                                        //limpiar local storage
                                                        saveFiltersToLocalStorage({
                                                            searchName,
                                                            SearchContacto,
                                                            SearchGiro: ''
                                                        });
                                                        document.getElementById('searchGiro').value = '';
                                                        document.getElementById('searchGiro').classList.remove('input-active');
                                                    }} />}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <Link to="/proveedores/nuevo">
                                    <button className='filter-use-button'>+ Crear Proveedor</button>
                                </Link>
                            </div>
                            <div className='delete-users' >
                                <button onClick={handleShowModalMulti} style={{ cursor: "pointer" }}><FiTrash2></FiTrash2> Eliminar</button>
                            </div>
                            {showMultiDeleteModal &&
                                <Modal
                                    selectedProviders={selectedProviders}
                                    initialOpen={true}
                                    close={() => setShowMultiDeleteModal(false)}
                                    onDelete={handleDeleteselectedProviders}
                                />
                            }
                            <div className='user-details'>
                                <table className='tabla-usuarios'>
                                    <thead>
                                        <tr className='tabla-header'>
                                            <th style={{ paddingTop: "2%", paddingBottom: "2%", paddingLeft: "3%", width: "7%" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectAll}
                                                    onChange={handleSelectAllChange}
                                                />
                                            </th>
                                            <th>Nombre</th>
                                            <th>Contacto</th>
                                            <th>Giro de Negocio</th>
                                            <th>Acciones</th>
                                        </tr>
                                        <tr className="separator">
                                            <td colSpan="5"></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentItems.map((provider, index) => (
                                            <React.Fragment key={provider.id}>
                                                <tr key={provider.id} >
                                                    <td style={{ paddingLeft: "3%" }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedProviders.some(u => u.id === provider.id)}
                                                            onChange={e => handleProvidersSelect(provider, e.target.checked)}
                                                        />
                                                    </td>
                                                    <td style={{ height: "9vh" }}>{provider.name}</td>
                                                    <td>{provider.contact ? provider.contact : ''}</td>
                                                    <td>{provider.business_turnover ? provider.business_turnover : ''}</td>
                                                    <td style={{ paddingLeft: "2%" }}>
                                                        <div className='menu-usuarios' ref={dropdownRef} onClick={(e) => e.stopPropagation()}>
                                                            <button className="icon-button" onClick={() => toggleDropdown(provider.id)}><CiMenuKebab /></button>

                                                            {!showMultiDeleteModal && dropdownOpen[provider.id] && (
                                                                <div className="dropdownMenu">
                                                                    <ul>
                                                                        <li><a className="dontCloseDropdown" onClick={() => goToEditProvider(provider)}><GrFormEdit></GrFormEdit>Editar</a></li>
                                                                        <li><a className="dontCloseDropdown" onClick={() => { setShowModalForProjectId(provider.id); setDropdownOpen({}); }}><FiTrash2></FiTrash2>Eliminar</a></li>
                                                                    </ul>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr className="separator">
                                                    <td colSpan="5"></td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                    </tbody>
                                </table>
                                <div className='paginador-usuarios'>
                                    <span>{currentPage} de {totalPages} </span>
                                    <div>
                                        <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}><MdArrowBackIosNew /> Anterior</button>
                                        {currentPage > 1 && <button onClick={() => paginate(currentPage - 1)}>{currentPage - 1}</button>}
                                        <button style={{ fontWeight: "bold" }} className={currentPage === currentPage ? "selected-page" : ""}>{currentPage}</button>
                                        {currentPage < totalPages && <button onClick={() => paginate(currentPage + 1)}>{currentPage + 1}</button>}
                                        <button onClick={() => paginate(currentPage + 1)} disabled={currentPage === totalPages}>Siguiente <MdArrowForwardIos /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            )
            }
            {
                showModalForprojectID &&
                <Modal
                    provider={Providers.find(u => u.id === showModalForprojectID)}
                    initialOpen={true}
                    close={() => setShowModalForProjectId(null)}
                    onDelete={() => handleModalDelete(showModalForprojectID)}
                />
            }
            {isLoading && <LoadingModal />}
        </>
    );
}

export default ListadoProveedores;